<template>
  <div class="alert-keyword">
    <div class="tooltip">{{ keyword.type }}:{{ keyword.value }}<span class="tooltiptext">Keyword</span></div>
  </div>
</template>

<style scoped>
.alert-keyword {
  display: inline-block;
  border: 1px solid #cccccc;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
  margin-top: -5px;
  /*margin-left: 3px;*/
  margin-right: 3px;
  padding-left: 2px;
  padding-right: 2px;
  vertical-align: middle;
}
/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  color: #fff;
  text-align: center;
  padding: 2px;
  margin-bottom: 5px;
  border-radius: 3px;
  background-color: #111;
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0%;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>

<script>
export default {
  name: 'AlertKeyword',
  props: {
    keyword: {
      type: Object,
      required: true
    }
  }
}
</script>
